import { css, styled } from "styled-components";
import { Timeline } from "antd";
import { type AppTimelineProps } from ".";

const centerWidth = 80;
const defaultLeftWidth = "30%";
const iconSize = 30;

export const StyledAppTimeline = styled(Timeline)<AppTimelineProps>`
  ${({ leftWidth }) => css`
    .ant-timeline-item {
      .ant-timeline-item-label {
        inset-inline-start: 0 !important;
        width: ${leftWidth || defaultLeftWidth} !important;
      }

      .ant-timeline-item-tail {
        inset-inline-start: calc(
          ${leftWidth || defaultLeftWidth} + ${centerWidth / 2}px
        ) !important;
        width: 1px !important;
      }

      .ant-timeline-item-head {
        inset-inline-start: calc(
          ${leftWidth || defaultLeftWidth} + ${centerWidth / 2}px
        ) !important;
        inset-block-start: calc(${iconSize / 2}px) !important;
        width: ${iconSize}px !important;
        height: ${iconSize}px !important;
      }

      .ant-timeline-item-content {
        inset-inline-start: calc(
          ${leftWidth || defaultLeftWidth} + ${centerWidth / 2}px
        ) !important;
        width: calc(
          100% - ${leftWidth || defaultLeftWidth} - ${centerWidth}px
        ) !important;
      }
    }
  `}
`;
